// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"46f22326","160":"6b0abd87","184":"572d1864","668":"7ddb472b","695":"f9956564","787":"96809e42"}[chunkId] + ".chunk.js";
};